const predictiveSearch = {
  call: null,
  init: () => {
    predictiveSearch.events();
  },
  events: () => {
    $(".reset__button").on("click", () => {
      $("form.search .predictive-search-results-holder").hide();
      $("form.search").removeClass("active");
      $('form.search input[name="q"]').val("");
    });

    $(document).on("click", (e) => {
      if (
        !$(e.target).closest(".predictive-search-results-holder").length &&
        !$(e.target).closest("form.search").length
      ) {
        $("form.search .predictive-search-results-holder").hide();
        $("form.search").removeClass("active");
      }
    });
  },
  submitSearch: () => {
    const form = $("form.search");
    const searchTerm = form.find('input[name="q"]').val();

    if (searchTerm.length < 3) {
      $("form.search .predictive-search-results-holder").hide();
      $("form.search").removeClass("active");
      return;
    }

    if (predictiveSearch.call) {
      predictiveSearch.call.abort();
    }

    var params = "?" + form.serialize();

    predictiveSearch.call = $.ajax({
      url:
        "/search/suggest" +
        params +
        "&section_id=predictive-search&resources[type]=product",
      type: "GET",
      beforeSend: () => {
        $("form.search").addClass("active");
        $("form.search .predictive-search-results-holder")
          .html('<p class="loader">Loading...</p>')
          .show();
      },
      success: (data) => {
        predictiveSearch.processSearchResults(data);
      },
      complete: () => {
        predictiveSearch.call = null;
      },
    });
  },
  processSearchResults: (data) => {
    $("form.search .predictive-search-results-holder").html(data).show();
  },
};

const header = {
  init: () => {
    header.events();
  },
  events: () => {
    $(document).on('click', '.button-back-to-top', function (e) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, 500);
    });

    $(document).on("click", "#search-toggle", function (e) {
      e.preventDefault();
      $("header").toggleClass("search-active");
    });

    $(document).on("click", ".open-cart-drawer", function (e) {
      e.preventDefault();
      $("cart-drawer").toggleClass("animate active");
    });
  },
};

const megaMenu = {
  init: () => {
    megaMenu.positioning();
    megaMenu.events();
  },

  positioning: () => {
    const megaMenu = $("#mega-menu");

    if (megaMenu.length > 0) {
      const megaMenuHeight = megaMenu.outerHeight();
      const menuBarHeight = $("header").outerHeight();
      const annBarHeight = $(".announcement_bar").outerHeight();

      var offset = annBarHeight + menuBarHeight;
      if ($(window).width() >= 1024) offset = 0;

      megaMenu.css("top", offset + "px");
    }
  },

  events: () => {
    $(document).on("click tap", "#mega-menu .side-menu > a", function (e) {
      if ($(this).data("slug")) {
        e.preventDefault();
        const slug = $(this).data("slug");
        const parent = $(this).closest(".block-menu");
        console.log(slug);
        parent.find(".side-menu a.active").removeClass("active");
        $(this).addClass("active");

        parent
          .find(".menu-item")
          .removeClass("active")
          .removeClass("mobile-active");
        parent
          .find('.menu-item[data-for="' + slug + '"]')
          .addClass("active")
          .addClass("mobile-active");

        if ($("#mega-menu").hasClass("mobile-active")) {
          $("#mega-menu").removeClass("step-1");
          $("#mega-menu").addClass("step-2");
        }
      }
    });

    $(document).on("click tap", "#menu-toggle", function (e) {
      e.preventDefault();

      $("#shopify-section-mega-menu").toggleClass("active");
      if ($(this).hasClass("is-active")) {
        $("#mega-menu").removeClass("mobile-active");
        $(this).removeClass("is-active");
        $("#mega-menu").removeClass("step-1");
        $("#mega-menu").removeClass("step-2");
      } else {
        $(this).addClass("is-active");
        $("#mega-menu").addClass("mobile-active");
        $("#mega-menu").removeClass("step-1");
        $("#mega-menu").removeClass("step-2");
      }
    });

    $(document).on(
      "click tap",
      "#mega-menu.mobile-active a.top-level",
      function (e) {
        if($(this).parent().hasClass('block-list') || $(this).parent().hasClass('block-menu')) {
          e.preventDefault();
          $(this).closest("li").addClass("active");
          $("#mega-menu").addClass("step-1");
        }
      }
    );

    $(document).on("click tap", "#mega-menu .mobile-link", function (e) {
      e.preventDefault();
      if ($("#mega-menu").hasClass("step-1")) {
        $("#mega-menu li.active").removeClass("active");
        $("#mega-menu").removeClass("step-1");
      } else if ($("#mega-menu").hasClass("step-2")) {
        $("#mega-menu").removeClass("step-2");
        $("#mega-menu").addClass("step-1");
      }
    });
  },
};

const cart = {
  init: () => {
    cart.events();
  },
  events: () => {
    $(document).on("click", ".cart__continue-shopping", function (e) {
      e.preventDefault();
      $("cart-drawer").removeClass("animate active");
    });

    $(document).on("submit", "form.product-form-container", function (e) {
      const quantity = $('input.product-basket__input').val();
      const title = $('h1.product__title').text().replace(/\s+/g, " ").trim();
      const price = parseFloat($('#total-price').text());
      const id = $(this).find('input[name="id"]').val();

      const product = {
        id: id,
        title: title,
        price: price,
        quantity: quantity
      }

      cart.add(product);
    });
  },
  add:(product) => {
    if(!product) {
      console.error('[cart] No product data provided for cart.add');
      return;
    }

    console.log('[cart] adding to dataLayer:', product);
    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "veritonicAddToCart",
      product_id: product.id,
      product_name: product.title,
      value: product.price,
      quantity: product.quantity
    });

  }
}

const collection = {
  init: () => {
    console.log('Collection init');

    const collectionHeroText = $('.collection-hero .text');
    if (collectionHeroText.length && collectionHeroText[0].scrollHeight > collectionHeroText.innerHeight()) {
      collectionHeroText.addClass('overflowing');
      $('.collection-hero').append('<a href="#" class="read-more">Read more</a>');
    }
    collection.events();
  },

  events: () => {
    $(document).on('click', '.collection-hero .read-more', function (e) {
      e.preventDefault();
      const $this = $(this);
      const collectionHeroText = $('.collection-hero .text');
      if (collectionHeroText.hasClass('overflowing')) {
        collectionHeroText.removeClass('overflowing').addClass('extended');
        $this.text('Read less');
      } else {
        collectionHeroText.addClass('overflowing').removeClass('extended');
        $this.text('Read more');
      }
    });
  },
}

const homeCollectionList = {
  resizing: () => {
    //for each '.section-home-collection-list' element, check that the total width of the children with a class '.collection' is less and the container. If more than the container, add a class to the container
    $('.section-home-collection-list').each(function () {
      const $this = $(this);
      const totalWidth = $this.find('.collection').toArray().reduce((acc, el) => acc + $(el).outerWidth(true), 0);

      const gap = parseInt($this.find('.collections').css('gap')) || 0;
      const padding = parseInt($this.find('.collections').css('padding-left')) * 2 || 0;

      const totalWidthWithGap = totalWidth + (gap * ($this.find('.collection').length - 1)) + padding; 
           
      if (totalWidthWithGap > $this.width()) {
        $this.find('.collections').addClass('overflowing');
      } else {
        $this.find('.collections').removeClass('overflowing');
      }
    });    
  }
}

$(window).on("resize", function () {
  megaMenu.positioning();
  if($('.section-home-collection-list').length) homeCollectionList.resizing();
});

$(() => {
  megaMenu.init();
  header.init();
  predictiveSearch.init();
  cart.init();
  if($('.section-home-collection-list').length) homeCollectionList.resizing();
  if($('body.collection---template').length) collection.init();
});
